import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map as map_1, head, tail, length, isEmpty, empty, ofArray, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { map, defaultArg, orElse } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { count, many, contentUrl as contentUrl_1 } from "../Api/Documents.fs.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { adminContent, ByCell, dateTimeCell, Labels } from "./Prelude.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, ExportReferences, ChangeReferences, Update } from "../Modals/Document.fs.js";
import { Components_UnDelete, Components_Delete, Components_ExportLabels, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { DomainEntity } from "../ClientTypes.fs.js";
import { many as many_1 } from "../Api/Entities.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", name]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function OpenExternal(openExternalInputProps) {
    let elems;
    const document$ = openExternalInputProps.document;
    const projectId = openExternalInputProps.projectId;
    const contentUrl = orElse(document$.CurrentRevision.ExternalSourceUrl, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((revisionId) => contentUrl_1(projectId, document$.Id, revisionId), (document$.CurrentRevision.ExternalSourceUrl != null) ? undefined : document$.CurrentRevision.RevisionId, [])));
    if (contentUrl != null) {
        return createElement("a", createObj(ofArray([["href", contentUrl], ["target", "_blank"], ["rel", "noopener noreferrer"], ["alt", document$.Name], (elems = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-external-link-alt"])), [])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return defaultOf();
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(9, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("uploadedOn", "Uploaded On", undefined), new Column("uploadedBy", "Uploaded By", undefined), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined), new Column("openExternal", "Open External", undefined)]);
}

function rowRender(projectId, document$) {
    return new Row(document$.Id, ofArray([new Cell("name", document$.Name), new Cell("detail", defaultArg(map((value_1) => value_1, document$.Detail), defaultOf())), new Cell("labels", createElement(Labels, {
        labels: document$.Labels,
    })), new Cell("uploadedOn", dateTimeCell(document$.CurrentRevision.UploadedOn)), new Cell("uploadedBy", createElement(ByCell, {
        projectId: projectId,
        by: document$.CurrentRevision.UploadedBy,
    })), new Cell("lastModifiedOn", dateTimeCell(document$.LastModified)), new Cell("openExternal", createElement(OpenExternal, {
        projectId: projectId,
        document: document$,
    }))]));
}

export function Documents(documentsInputProps) {
    let actions, documents, documents_1;
    const projectId = documentsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedDocuments = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const filters = patternInput_4[0];
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Documents",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (documentParams) => many(projectId, empty(), documentParams),
        fetchCount: (documentParams_1) => count(projectId, documentParams_1),
        rowRender: (document$) => rowRender(projectId, document$),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedDocuments);
    const isMoreThan1 = length(selectedDocuments) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change References"], ["onClick", (_arg_3) => {
        setAction("changeReferences");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_4) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedDocuments) ? true : showDeleted]]))))), delay(() => append(showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_5) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedDocuments)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_6) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedDocuments)]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export References"], ["onClick", (_arg_7) => {
        setAction("exportReferences");
    }]]))))), delay(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export Labels"], ["onClick", (_arg_8) => {
        setAction("exportLabels");
    }]]))))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedDocuments) ? (isEmpty(tail(selectedDocuments)) ? createElement(Update, {
        projectId: projectId,
        document: head(selectedDocuments),
        close: close,
    }) : undefined) : undefined) : ((actions === "changeReferences") ? (!isEmpty(selectedDocuments) ? (isEmpty(tail(selectedDocuments)) ? createElement(ChangeReferences, {
        projectId: projectId,
        document: head(selectedDocuments),
        close: close,
    }) : undefined) : undefined) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map_1((document$_3) => [new DomainEntity(9, [document$_3]), document$_3.Labels], selectedDocuments),
        close: close,
    }) : ((actions === "exportReferences") ? createElement(ExportReferences, {
        projectId: projectId,
        filters: filters,
        close: () => {
            close(false);
        },
    }) : ((actions === "exportLabels") ? createElement(Components_ExportLabels, {
        entityType: new DomainEntities(9, []),
        countApi: () => count(projectId, filters),
        fetchApi: (apiParams_1) => many_1(new DomainEntities(9, []), projectId, apiParams_1, filters),
        close: () => {
            close(false);
        },
    }) : ((actions === "delete") ? ((documents = map_1((Item) => (new DomainEntity(9, [Item])), selectedDocuments), createElement(Components_Delete, {
        projectId: projectId,
        entities: documents,
        close: close,
    }))) : ((actions === "unDelete") ? ((documents_1 = map_1((Item_1) => (new DomainEntity(9, [Item_1])), selectedDocuments), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: documents_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))))))) : undefined);
}

